// tslint:disable: max-line-length
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ButtonLarge } from './../../app/common/sharedComponents/buttons/ButtonLarge';
import { getUserDataByToken } from './apiCaller';
import { useLocation, useNavigate } from 'react-router-dom';
import { showErrorMessage } from '../../helpers/showMessage';
import { clear } from '../../utils/localStorage';
import { NotLoggedInHeader } from './../../app/common/sharedComponents/NotLoggedInHeader';
import { useTranslation } from 'react-i18next';
import { Modal } from './../../app/common/sharedComponents/Modal';
import { Headline3, Headline4 } from './../../app/common/typography';
import { ButtonBlockColumn } from './../../app/common/sharedStyledComponents/GenericStyles.styled';

const LoginContainer = styled('div')`
  & .phone-input-dropdown input[disabled],
  & .control-input:has(input[disabled]) {
    background-color: #e1e1e1;
  }
`;

const InputContainer = styled('div')`
  padding: 0rem 1rem 1rem 1rem;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 1rem;
`;

const Input = styled('input')<{ errorStatus: boolean }>`
  box-sizing: border-box;
  width: 45px;
  height: 50px;
  background: #ffffff;
  border: ${({ errorStatus }) =>
    errorStatus ? '1px solid #FF3B30' : '1px solid #919191'};
  border-radius: 4px;
  text-align: center;
  font-size: 22px;
  font-weight: bold;
`;

const Title = styled('h3')`
  color: #031c38;
  font-family: Source Sans Pro;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 34px; /* 141.667% */
  margin: 0px;
  padding: 0 1rem 0 1rem;
`;

const Subtitle = styled('h3')`
  color: var(--gray-400, #919191);
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-family: Source Sans Pro;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 146.667% */
  padding: 0 1rem 0 1rem;
  margin-bottom: 0px;
`;

const ButtonContainer = styled.div`
  margin: 0 10px;
`;

const TitleHotelSecret = styled.div`
  margin-bottom: 30px;
  text-align: center;
`;

const TextHotelSecret = styled.div`
  padding: 5px 0 20px;
`;

const ButtonCloseContainer = styled.div`
  margin: 30px 0;
`;

const PinCode = () => {
  const { t } = useTranslation();
  const [pin, setPin] = useState<string[]>(Array(6).fill(''));
  const [hotelPin, setHotelPin] = useState<string[]>(Array(6).fill(''));
  const [errorStatus, setErrorStatus] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [isValidHotelKey, setIsValidHotelKey] = useState(true);
  const [isActiveCode, setIsActiveCode] = useState(false);
  const [isActiveHotelKey, setIsActiveHotelKey] = useState(false);
  const [isOpenKeyIncorrect, setIsOpenKeyIncorrect] = useState<boolean>(false);
  const [isOpenCodeUtilised, setIsOpenCodeUtilised] = useState<boolean>(false);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const loc: any = { ...location };
  const isDeactivatedUser: any | null =
    (loc && loc.state && loc.state.isDeactivatedUser) || false;

  const navigate = useNavigate();
  useEffect(() => {
    if (!isDeactivatedUser) {
      clear();
    }
  }, [isDeactivatedUser]);
  const verifyTokenData = () => {
    setIsLoading(true);
    const token = pin.join('').toLowerCase();
    const tokenHotel = hotelPin.join('');

    if (pin.includes('')) {
      // setIsValid(false);
      setIsActiveCode(!isActiveCode);
      return;
    }
    if (hotelPin.includes('')) {
      setIsActiveHotelKey(!isActiveHotelKey);
      return;
    }
    getUserDataByToken(token, tokenHotel.toUpperCase())
      .then((res) => {
        if (res.isProfileCreated) {
          showErrorMessage('Profile already created.');
          // navigate('/login');
          window.location.href = '/login';
          return;
        }
        navigate('/createProfile', {
          state: { token, ...res, isDeactivatedUser },
        });
      })
      .catch((err) => {
        if (err && err.response && err.response.data) {
          switch (err.response.data.statusCode) {
            case 403:
              setIsOpenKeyIncorrect(true);
              setIsValidHotelKey(false);
              break;

            case 404:
              setIsValid(false);
              setErrorStatus(!errorStatus);
              break;

            case 409:
              setIsOpenCodeUtilised(true);
              break;
            default:
              console.error(err);
              break;
          }
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleChangeInput = (e, index) => {
    setPin([...pin.map((d, i) => (i === index ? e.value : d))]);
    // Focus Previous
    setIsValid(true);
    setIsActiveCode(false);
    setErrorStatus(false);

    if (e.value === '') {
      if (e.previousSibling && e.previousSibling instanceof HTMLInputElement) {
        e.previousSibling.focus();
      }
      return false;
    }
    // Focus Next
    if (e.nextSibling && e.nextSibling instanceof HTMLInputElement) {
      e.nextSibling.focus();
    }
    return false;
  };

  const handleChangeHotelPinInput = (e, index) => {
    setHotelPin([...hotelPin.map((d, i) => (i === index ? e.value : d))]);
    // Focus Previous
    setIsValidHotelKey(true);
    setIsActiveHotelKey(false);

    if (e.value === '') {
      if (e.previousSibling && e.previousSibling instanceof HTMLInputElement) {
        e.previousSibling.focus();
      }
      return false;
    }
    // Focus Next
    if (e.nextSibling && e.nextSibling instanceof HTMLInputElement) {
      e.nextSibling.focus();
    }
    return false;
  };

  const handlePaste = (e, index) => {
    e.preventDefault();
    if (index === 0) {
      const clipboardData = e.clipboardData || (window as any).clipboardData;
      const pastedText = clipboardData.getData('text');

      setPin((prevPin) => {
        const newHotelPin = [...prevPin];
        newHotelPin.splice(
          index,
          pastedText.length,
          ...pastedText.substring(0, 6).toUpperCase().split('')
        );
        return newHotelPin;
      });
    }
  };
  const handlePasteHotelKey = (e, index) => {
    e.preventDefault();
    if (index === 0) {
      const clipboardData = e.clipboardData || (window as any).clipboardData;
      const pastedText = clipboardData.getData('text');

      setHotelPin((prevPin) => {
        const newHotelPin = [...prevPin];
        newHotelPin.splice(
          index,
          pastedText.length,
          ...pastedText.substring(0, 6).toUpperCase().split('')
        );
        return newHotelPin;
      });
    }
  };

  const handleBackButton = (e) => {
    e.preventDefault();
    window.location.href = isDeactivatedUser ? '/dashboard' : '/login';
  };
  return (
    <>
      <LoginContainer>
        <NotLoggedInHeader
          isRegistering={true}
          step={1}
          isDeactivatedUser={isDeactivatedUser}
        />
        <div>
          <Title>Enter Your Activation Code</Title>
          <Subtitle>You will have received this via Phone or email</Subtitle>
        </div>

        <div className="" style={{ marginTop: '6px' }}>
          <InputContainer>
            {pin.map((data, index) => {
              return (
                <Input
                  type="text"
                  maxLength="1"
                  key={index}
                  value={data.toUpperCase()}
                  onChange={(e) => handleChangeInput(e.target, index)}
                  onFocus={(e) => e.target.select()}
                  errorStatus={errorStatus}
                  onPaste={(e) => handlePaste(e, index)}
                />
              );
            })}
          </InputContainer>
          {isActiveCode && isValid ? (
            <span className="d-flex  justify-center fw-400 f-17 lh-22 sans-font font-normal color-red pl-20">
              {' '}
              Activation Code is required.
            </span>
          ) : (
            <span className="lh-22" />
          )}
          {!isValid ? (
            <span className="d-flex  justify-center fw-400 f-17 lh-22 sans-font font-normal color-red pl-20">
              {' '}
              Invalid Code, please try again
            </span>
          ) : (
            <span className="lh-22" />
          )}
        </div>
        <div>
          <Title>Enter Hotel Secret Key</Title>
          <Subtitle>You will have received this from your manager</Subtitle>
        </div>

        <div className="" style={{ marginTop: '6px' }}>
          <InputContainer>
            {hotelPin.map((data, index) => {
              return (
                <Input
                  type="text"
                  maxLength="1"
                  key={index}
                  value={data.toUpperCase()}
                  onChange={(e) => handleChangeHotelPinInput(e.target, index)}
                  onFocus={(e) => e.target.select()}
                  errorStatus={!isValidHotelKey || isActiveHotelKey}
                  onPaste={(e) => handlePasteHotelKey(e, index)}
                />
              );
            })}
          </InputContainer>
          {isActiveHotelKey && isValidHotelKey ? (
            <span className="d-flex justify-center fw-400 f-17 lh-22 sans-font font-normal color-red pl-20">
              {' '}
              Hotel Secret Key is required.
            </span>
          ) : (
            <span className="lh-22" />
          )}
        </div>
        <ButtonContainer>
          <ButtonLarge
            title={isValid && isValidHotelKey ? 'Verify' : 'Try Again'}
            onClick={() => {
              verifyTokenData();
            }}
            loading={isLoading}
            backgroundColor="oxfordBlue"
            disabled={
              pin.join('').length < 6 || hotelPin.join('').length < 6
                ? true
                : false
            }
          />
        </ButtonContainer>
      </LoginContainer>
      {isOpenKeyIncorrect && (
        <Modal isOpen={isOpenKeyIncorrect}>
          <TitleHotelSecret>
            <Headline3>Hotel Secret Key Incorrect</Headline3>
          </TitleHotelSecret>
          <TextHotelSecret>
            <Headline4 color="dimGray">
              The Hotel Secret Key you are attempting to use has expired or is
              incorrect. Please contact your hotel administrator for the correct
              code
            </Headline4>
          </TextHotelSecret>
          <hr color="#9797AA" />
          <ButtonCloseContainer>
            <ButtonLarge
              onClick={() => {
                setIsOpenKeyIncorrect(false);
              }}
              title={t('COMMON.OUTSIDE.BUTTONS.CLOSE')}
            />
          </ButtonCloseContainer>
        </Modal>
      )}
      {isOpenCodeUtilised && (
        <Modal isOpen={isOpenCodeUtilised}>
          <TitleHotelSecret>
            <Headline3>Registration code Utilised</Headline3>
          </TitleHotelSecret>
          <TextHotelSecret>
            <Headline4 color="dimGray">
              The registration code has been utilised. Please log in instead
              using your credentials. If you have any difficulties logging in,
              contact your hotel’s administrator for further assistance
            </Headline4>
          </TextHotelSecret>
          <hr color="#9797AA" />
          <ButtonCloseContainer>
            <ButtonBlockColumn>
              <ButtonLarge
                title={t('COMMON.OUTSIDE.BUTTONS.LOG_IN')}
                onClick={(event) => {
                  handleBackButton(event);
                }}
                backgroundColor="oxfordBlue"
              />
              <ButtonLarge
                onClick={() => {
                  setIsOpenCodeUtilised(false);
                }}
                title={t('COMMON.OUTSIDE.BUTTONS.CANCEL')}
                outlined={true}
                inverted={true}
              />
            </ButtonBlockColumn>
          </ButtonCloseContainer>
        </Modal>
      )}
    </>
  );
};

export default PinCode;
